/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Reviews_Overallscore2Inputs */

const id_offerdetail_reviews_overallscore2 = /** @type {(inputs: Offerdetail_Reviews_Overallscore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skor Keseluruhan`)
};

const ms_offerdetail_reviews_overallscore2 = /** @type {(inputs: Offerdetail_Reviews_Overallscore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skor Keseluruhan`)
};

const da_offerdetail_reviews_overallscore2 = /** @type {(inputs: Offerdetail_Reviews_Overallscore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Samlet Score`)
};

const de_offerdetail_reviews_overallscore2 = /** @type {(inputs: Offerdetail_Reviews_Overallscore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gesamtpunktzahl`)
};

const en_us2_offerdetail_reviews_overallscore2 = /** @type {(inputs: Offerdetail_Reviews_Overallscore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Overall Score`)
};

const es_es2_offerdetail_reviews_overallscore2 = /** @type {(inputs: Offerdetail_Reviews_Overallscore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puntuación general`)
};

const es_mx2_offerdetail_reviews_overallscore2 = /** @type {(inputs: Offerdetail_Reviews_Overallscore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puntuación general`)
};

const fil_offerdetail_reviews_overallscore2 = /** @type {(inputs: Offerdetail_Reviews_Overallscore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kabuuang Puntos`)
};

const fr_offerdetail_reviews_overallscore2 = /** @type {(inputs: Offerdetail_Reviews_Overallscore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Score global`)
};

const it_offerdetail_reviews_overallscore2 = /** @type {(inputs: Offerdetail_Reviews_Overallscore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Punteggio complessivo`)
};

const hu_offerdetail_reviews_overallscore2 = /** @type {(inputs: Offerdetail_Reviews_Overallscore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Összpontszám`)
};

const nl_offerdetail_reviews_overallscore2 = /** @type {(inputs: Offerdetail_Reviews_Overallscore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Algemene score`)
};

const no_offerdetail_reviews_overallscore2 = /** @type {(inputs: Offerdetail_Reviews_Overallscore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Samlet poengsum`)
};

const pl_offerdetail_reviews_overallscore2 = /** @type {(inputs: Offerdetail_Reviews_Overallscore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ogólny wynik`)
};

const pt_br2_offerdetail_reviews_overallscore2 = /** @type {(inputs: Offerdetail_Reviews_Overallscore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pontuação geral`)
};

const pt_offerdetail_reviews_overallscore2 = /** @type {(inputs: Offerdetail_Reviews_Overallscore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pontuação geral`)
};

const ro_offerdetail_reviews_overallscore2 = /** @type {(inputs: Offerdetail_Reviews_Overallscore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scor general`)
};

const fi_offerdetail_reviews_overallscore2 = /** @type {(inputs: Offerdetail_Reviews_Overallscore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kokonaispisteet`)
};

const sv_offerdetail_reviews_overallscore2 = /** @type {(inputs: Offerdetail_Reviews_Overallscore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Totalpoäng`)
};

const vi_offerdetail_reviews_overallscore2 = /** @type {(inputs: Offerdetail_Reviews_Overallscore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Điểm tổng thể`)
};

const tr_offerdetail_reviews_overallscore2 = /** @type {(inputs: Offerdetail_Reviews_Overallscore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genel Puan`)
};

const cs_offerdetail_reviews_overallscore2 = /** @type {(inputs: Offerdetail_Reviews_Overallscore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Celkové skóre`)
};

const bg_offerdetail_reviews_overallscore2 = /** @type {(inputs: Offerdetail_Reviews_Overallscore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Общ резултат`)
};

const ru_offerdetail_reviews_overallscore2 = /** @type {(inputs: Offerdetail_Reviews_Overallscore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Общий балл`)
};

const uk_offerdetail_reviews_overallscore2 = /** @type {(inputs: Offerdetail_Reviews_Overallscore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Загальна оцінка`)
};

const ar_offerdetail_reviews_overallscore2 = /** @type {(inputs: Offerdetail_Reviews_Overallscore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`النتيجة الإجمالية`)
};

const hi_offerdetail_reviews_overallscore2 = /** @type {(inputs: Offerdetail_Reviews_Overallscore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कुल स्कोर`)
};

const th_offerdetail_reviews_overallscore2 = /** @type {(inputs: Offerdetail_Reviews_Overallscore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คะแนนรวม`)
};

const ja_offerdetail_reviews_overallscore2 = /** @type {(inputs: Offerdetail_Reviews_Overallscore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`総合スコア`)
};

const zh_cn2_offerdetail_reviews_overallscore2 = /** @type {(inputs: Offerdetail_Reviews_Overallscore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`总分`)
};

const zh_hant1_offerdetail_reviews_overallscore2 = /** @type {(inputs: Offerdetail_Reviews_Overallscore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`總分`)
};

const ko_offerdetail_reviews_overallscore2 = /** @type {(inputs: Offerdetail_Reviews_Overallscore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`전체 점수`)
};

/**
* | output |
* | --- |
* | "Overall Score" |
*
* @param {Offerdetail_Reviews_Overallscore2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_reviews_overallscore2 = /** @type {((inputs?: Offerdetail_Reviews_Overallscore2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Reviews_Overallscore2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_reviews_overallscore2(inputs)
	if (locale === "ms") return ms_offerdetail_reviews_overallscore2(inputs)
	if (locale === "da") return da_offerdetail_reviews_overallscore2(inputs)
	if (locale === "de") return de_offerdetail_reviews_overallscore2(inputs)
	if (locale === "en-US") return en_us2_offerdetail_reviews_overallscore2(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_reviews_overallscore2(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_reviews_overallscore2(inputs)
	if (locale === "fil") return fil_offerdetail_reviews_overallscore2(inputs)
	if (locale === "fr") return fr_offerdetail_reviews_overallscore2(inputs)
	if (locale === "it") return it_offerdetail_reviews_overallscore2(inputs)
	if (locale === "hu") return hu_offerdetail_reviews_overallscore2(inputs)
	if (locale === "nl") return nl_offerdetail_reviews_overallscore2(inputs)
	if (locale === "no") return no_offerdetail_reviews_overallscore2(inputs)
	if (locale === "pl") return pl_offerdetail_reviews_overallscore2(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_reviews_overallscore2(inputs)
	if (locale === "pt") return pt_offerdetail_reviews_overallscore2(inputs)
	if (locale === "ro") return ro_offerdetail_reviews_overallscore2(inputs)
	if (locale === "fi") return fi_offerdetail_reviews_overallscore2(inputs)
	if (locale === "sv") return sv_offerdetail_reviews_overallscore2(inputs)
	if (locale === "vi") return vi_offerdetail_reviews_overallscore2(inputs)
	if (locale === "tr") return tr_offerdetail_reviews_overallscore2(inputs)
	if (locale === "cs") return cs_offerdetail_reviews_overallscore2(inputs)
	if (locale === "bg") return bg_offerdetail_reviews_overallscore2(inputs)
	if (locale === "ru") return ru_offerdetail_reviews_overallscore2(inputs)
	if (locale === "uk") return uk_offerdetail_reviews_overallscore2(inputs)
	if (locale === "ar") return ar_offerdetail_reviews_overallscore2(inputs)
	if (locale === "hi") return hi_offerdetail_reviews_overallscore2(inputs)
	if (locale === "th") return th_offerdetail_reviews_overallscore2(inputs)
	if (locale === "ja") return ja_offerdetail_reviews_overallscore2(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_reviews_overallscore2(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_reviews_overallscore2(inputs)
	return ko_offerdetail_reviews_overallscore2(inputs)
});
export { offerdetail_reviews_overallscore2 as "offerDetail.reviews.overallScore" }